export enum TripTypology {
  REAL = 'real',
  SAMPLE = 'sample',
  SUPER_SAMPLE = 'super-sample',
  TEST = 'test',
  SANDBOX = 'sandbox',
}
